import router from './router';
import store from './store';
import { getToken } from '@/utils/auth'; // 验权

router.afterEach((to, from, next) => {
	// console.log(store.getters.company,to)
	// console.log(store)
	// document.title = `${to.name || to.meta.name || ''} - ${store.getters.company}`;
});


// WEBPACK FOOTER //
// ./src/permission.js